import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import "bootstrap/dist/css/bootstrap.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Acepta(props) {
  const [id] = useState(props.match.params.id);
  const [plataforma, setPlataforma] = useState("");
  const [logo, setLogo] = useState("");
  const [checkComunicados, setComunicados] = useState(false);
  const { t, i18n } = useTranslation();

  const enlace = JSON.parse(localStorage.getItem("enlace"));

  const redireccion = props => {
    props.history.push(
      "/" +
        props.match.params.id
    );
  };

  if (!enlace) {
    redireccion(props);
  }

  const selectIdioma = event => {
    i18n.changeLanguage(event.target.value);
  };
  const handleChange = event => {
    setComunicados(event.target.checked);
    localStorage.setItem("acepto", event.target.checked);

  };

  useEffect(() => {
    getconfiguracionLocal();
  });

  const getconfiguracionLocal = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      "/api/dataLocalLogin?local=" + props.match.params.id,
      requestOptions
    );
    const result = await response.json();
    setLogo(result.local.logo);
    setPlataforma(result.local.plataforma);
  };

  const handleSubmit = event => {
    event.preventDefault();
    const googleUser = JSON.parse(localStorage.getItem("googleUser"));
    const facebookUser = JSON.parse(localStorage.getItem("facebookUser"));
    const user = JSON.parse(localStorage.getItem("user"));
    const enlace = JSON.parse(localStorage.getItem("enlace"));

    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        googleUser,
        facebookUser,
        establecimiento: id,
        plataforma: plataforma,
        usuario: user,
        locale: navigator.language || navigator.userLanguage,
        checkComunicados,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch("/apiLogin/" + plataforma + "/loginAcepto", requestOptions)
      .then(response => {
        return response.text();
      })
      .then(data => {
        const json = JSON.parse(data);
        if (json.ok) {
          if (enlace) {
            window.location.href = enlace;
          } else if (json.enlace) {
            window.location.href = json.enlace;
          }
          return null;
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <div className="login-form">
      <div className="dropdown select-idioma">
        <button className="dropbtn">{t("idioma.label")}</button>
        <div className="dropdown-content">
          <button
            className="botones-idiomas"
            value={"es"}
            onClick={selectIdioma}
          >
            {t("es.label")}
          </button>
          <button
            className="botones-idiomas"
            value={"en"}
            onClick={selectIdioma}
          >
            {t("en.label")}
          </button>
        </div>
      </div>
      <div className="clear"></div>

      <form onSubmit={handleSubmit}>
        {logo && (
          (
          <img
              className="logo"
              src={`https://imageswfz.s3-eu-west-1.amazonaws.com/login/` + logo}
              alt="Logo"
            />
        ))}
        <h4 className="modal-title">{t("datosPersonales.label")}</h4>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChange}
              name="checkComunicados"
              color="primary"
            />
          }
          className="texto-condiciones"
          label={
            <div>
              <Link className="link-condiciones" to="/politica" target="_blank">
                {t("comunicados.label")}
              </Link>
            </div>
          }
        />
        <input
          type="submit"
          className="btn btn-primary btn-block btn-lg texto-boton"
          value={t("accede.label")}
        />
      </form>
    </div>
  );
}

export default withRouter(Acepta);
